export function scrollToTop(containerBlock) {
  let container = $(`${containerBlock}`);
  container.animate({ scrollTop: 0 }, 'slow');
}
